import { AxiosResponse } from 'axios';
import { UseQueryOptions } from 'react-query';
import { ServiceError } from '../../../../../hooks/error';
import { useCustomMutate, useCustomPostQuery, useCustomQuery } from '../../../../../hooks/query';
import { PaginatedData } from '../../../../../models/List';
import { RawCandidateItemResponse } from '../../../../../models/RawCandidate';
import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { IExamMasterCodeItem } from '../../../../user/model';
import {
  getCandidateInfoToBeUpdated,
  getFilterListing,
  postCandidateCheckEmailEligibility,
  postCandidateCreateExportExcel,
  postCandidateCreateGenerate,
  postCandidateCreateSendEmail,
  postRawCandidateSearch,
  putUpdateAuthenticationType,
} from '../api-services/api';
import {
  CandidateInfoToBeUpdatedResponse,
  CreateCandidateFunctionRequest,
  CreateCheckEmailEligibilityResponse,
  FilterTypeCode,
  RawCandidateFunctionRequest,
  RawCandidateRequest,
} from '../models';
import {
  GET_CANDIDATE_INFO_TO_BE_UPDATED,
  GET_FILTER_LISTING,
  POST_CANDIDATE_CREATE_CHECK_EMAIL_ELIGIBILITY,
  POST_CANDIDATE_CREATE_EXPORT_EXCEL,
  POST_CANDIDATE_CREATE_GENERATE,
  POST_CANDIDATE_CREATE_SEND_EMAIL,
  POST_RAW_CANDIDATE_SEARCH,
  PUT_UPDATE_AUTHENTICATION_TYPE,
} from './keys';

export const useGetFilterListing = (typeCode: FilterTypeCode, functionName: String) =>
    useCustomQuery<IExamMasterCodeItem[]>(
        [GET_FILTER_LISTING, typeCode],
        () => getFilterListing(typeCode, functionName).then((res) => res.data),
        {
          staleTime: Infinity,
        }
    );

export const usePostRawCandidateSearch = (
  paging: ApiPathParam,
  payload: RawCandidateRequest,
  queryOptions: UseQueryOptions<
    AxiosResponse<PaginatedData<RawCandidateItemResponse>>,
    ServiceError,
    AxiosResponse<PaginatedData<RawCandidateItemResponse>>
  >
) =>
  useCustomPostQuery<AxiosResponse<PaginatedData<RawCandidateItemResponse>>, RawCandidateRequest>(
    [POST_RAW_CANDIDATE_SEARCH, paging, payload],
    (csrfToken, data) => postRawCandidateSearch(csrfToken, data, paging),
    queryOptions,
    payload
  );

export const usePostCandidateCreateGenerate = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate(POST_CANDIDATE_CREATE_GENERATE, postCandidateCreateGenerate, {
    onSuccess,
    onError,
  });

export const usePostCandidateCheckEmailEligibility = (
    onSuccess: (res: any) => void,
    onError: (res: any) => void
) =>
    useCustomMutate<AxiosResponse<CreateCheckEmailEligibilityResponse>, RawCandidateFunctionRequest>(
        POST_CANDIDATE_CREATE_CHECK_EMAIL_ELIGIBILITY,
        postCandidateCheckEmailEligibility, {
      onSuccess,
      onError,
    });

export const usePostCandidateCreateSendEmail = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate(POST_CANDIDATE_CREATE_SEND_EMAIL, postCandidateCreateSendEmail, {
    onSuccess,
    onError,
  });

export const usePostCandidateCreateExportExcel = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate(POST_CANDIDATE_CREATE_EXPORT_EXCEL, postCandidateCreateExportExcel, {
    onSuccess,
    onError,
  });

export const useGetCandidateInfoToBeUpdated = (data: CreateCandidateFunctionRequest) =>
  useCustomQuery<CandidateInfoToBeUpdatedResponse>(
    [GET_CANDIDATE_INFO_TO_BE_UPDATED, data],
    () => getCandidateInfoToBeUpdated(data).then((res) => res.data)
  );

export const usePutUpdateAuthenticationType = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate(PUT_UPDATE_AUTHENTICATION_TYPE, putUpdateAuthenticationType, {
    onSuccess,
    onError,
  });
